// src/data/comedians/trevor-noah.js

const base = {
  id: 'trevor-noah',
  slug: 'trevor-noah',
  name: 'Trevor Noah',
  birthYear: 1984,
  image: require('@/assets/images/img_Trevor_Noah.jpg'),
  famousWorks: [
    'The Daily Show (2015-2022)',
    'Born a Crime (memoir)',
    'Son of Patricia (2018)',
    'Afraid of the Dark (2017)',
    'I Wish You Would (2022)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'South African',
    shortBio: 'Daily Show host and global perspective',
    bio: `Trevor Noah is a South African comedian, television host, and political commentator who became internationally known as host of "The Daily Show" on Comedy Central from 2015 to 2022. His unique perspective as someone born during apartheid in South Africa has given him a distinctive voice in American comedy and political commentary.\n\nBorn in Johannesburg during apartheid to a black South African mother and white Swiss father, Noah's existence was itself illegal under apartheid law. His memoir "Born a Crime" details his extraordinary childhood and became a bestseller. He began his career in South Africa as a comedian, actor, and television host before gaining international attention.\n\nNoah's tenure on "The Daily Show" showcased his ability to analyze American politics and culture from an outsider's perspective, offering insights that resonated with diverse audiences. His stand-up specials demonstrate his skill at navigating different cultures and languages, making him one of the most internationally successful comedians of his generation.`,
    style: 'Political satire, cultural observation, multilingual, international perspective',
    achievements: [
      'Emmy nominations',
      'NAACP Image Awards',
      'New York Times bestselling author',
      'Time 100 most influential people',
      'Successful world tours',
      'Primetime Emmy Award',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Sud-Africain',
    shortBio: 'Animateur du Daily Show et perspective mondiale',
    bio: `Trevor Noah est un comédien, animateur de télévision et commentateur politique sud-africain connu internationalement comme animateur de "The Daily Show" sur Comedy Central de 2015 à 2022. Sa perspective unique en tant que personne née pendant l'apartheid en Afrique du Sud lui donne une voix distinctive dans la comédie et le commentaire politique américains.\n\nNé à Johannesburg pendant l'apartheid d'une mère noire sud-africaine et d'un père suisse blanc, l'existence même de Noah était illégale sous les lois de l'apartheid. Son mémoire "Born a Crime" détaille son enfance extraordinaire et est devenu un best-seller.\n\nSon passage à "The Daily Show" a mis en valeur sa capacité à analyser la politique et la culture américaines depuis une perspective extérieure. Ses specials stand-up démontrent son talent à naviguer entre différentes cultures et langues.`,
    style: 'Satire politique, observation culturelle, multilingue, perspective internationale',
    achievements: [
      'Nominations aux Emmy',
      'NAACP Image Awards',
      'Auteur de best-sellers du New York Times',
      'Time 100 personnalités les plus influentes',
      'Tournées mondiales réussies',
      'Primetime Emmy Award',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Sudafricano',
    shortBio: 'Presentador del Daily Show y perspectiva global',
    bio: `Trevor Noah es un comediante, presentador de televisión y comentarista político sudafricano conocido internacionalmente como presentador de "The Daily Show" en Comedy Central de 2015 a 2022. Su perspectiva única como alguien nacido durante el apartheid en Sudáfrica le da una voz distintiva en la comedia americana y el comentario político.\n\nNacido en Johannesburgo durante el apartheid, hijo de una madre sudafricana negra y un padre suizo blanco, la propia existencia de Noah era ilegal bajo las leyes del apartheid. Su memorias "Born a Crime" detalla su extraordinaria infancia y se convirtió en un bestseller.\n\nSu período en "The Daily Show" mostró su capacidad para analizar la política y la cultura americanas desde una perspectiva exterior. Sus especiales de stand-up demuestran su habilidad para navegar entre diferentes culturas e idiomas.`,
    style: 'Sátira política, observación cultural, multilingüe, perspectiva internacional',
    achievements: [
      'Nominaciones al Emmy',
      'NAACP Image Awards',
      'Autor de bestsellers del New York Times',
      'Time 100 personas más influyentes',
      'Giras mundiales exitosas',
      'Primetime Emmy Award',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'جنوب أفريقي',
    shortBio: 'مضيف The Daily Show وصاحب المنظور العالمي',
    bio: `تريفور نوا كوميدي ومقدّم تلفزيوني ومعلّق سياسي جنوب أفريقي اشتُهر عالميًا بتقديمه "The Daily Show" على Comedy Central من 2015 إلى 2022. منظوره الفريد بوصفه مولودًا إبّان نظام الفصل العنصري في جنوب أفريقيا أعطاه صوتًا مميزًا في الكوميديا الأمريكية والتعليق السياسي.\n\nوُلد في جوهانسبورغ إبّان الأبارتهايد من أم جنوب أفريقية سوداء وأب سويسري أبيض، وكان وجوده ذاته مخالفًا للقانون في ظل نظام الفصل. مذكراته "Born a Crime" تصف طفولته الاستثنائية وأصبحت من أكثر الكتب مبيعًا.\n\nأثبتت فترته في "The Daily Show" قدرته على تحليل السياسة والثقافة الأمريكيتين من منظور خارجي. تُظهر عروضه الخاصة مهارته في التنقل بين الثقافات واللغات المختلفة.`,
    style: 'ساخر سياسي، ملاحظ ثقافي، متعدد اللغات، منظور دولي',
    achievements: [
      'ترشيحات Emmy',
      'NAACP Image Awards',
      'مؤلف كتب من قوائم New York Times للأكثر مبيعًا',
      'قائمة Time 100 للشخصيات الأكثر تأثيرًا',
      'جولات عالمية ناجحة',
      'Primetime Emmy Award',
    ],
  },
];
